import { ReactNode } from 'react'
import { clsx } from 'clsx'

interface StatCardProps {
  label: string
  value: string | number
  icon?: ReactNode
  className?: string
  variant?: 'default' | 'primary' | 'success' | 'warning' | 'danger'
  trend?: {
    value: string
    direction: 'up' | 'down' | 'neutral'
  }
}

export const StatCard = ({
  label,
  value,
  icon,
  className,
  variant = 'default',
  trend,
}: StatCardProps) => {
  const variantStyles = {
    default: 'text-gray-900 dark:text-white',
    primary: 'text-primary-600 dark:text-primary-400',
    success: 'text-green-600 dark:text-green-400',
    warning: 'text-amber-600 dark:text-amber-400',
    danger: 'text-red-600 dark:text-red-400',
  }[variant]

  const trendStyles = trend ? {
    up: 'text-green-600 dark:text-green-400',
    down: 'text-red-600 dark:text-red-400',
    neutral: 'text-gray-500 dark:text-gray-400',
  }[trend.direction] : ''

  return (
    <div className={clsx(
      'bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700',
      'px-5 py-4 transition-all duration-200 hover:shadow-md',
      className
    )}>
      <div className="flex items-start justify-between">
        <div className="w-full">
          <div className="flex items-center space-x-3 mb-4">
            {icon && (
              <div className={clsx('flex-shrink-0', variantStyles)}>
                {icon}
              </div>
            )}
            <h3 className="text-sm font-normal text-gray-500 dark:text-gray-400">
              {label}
            </h3>
          </div>
          
          <div className="flex items-end justify-between">
            <p className={clsx(
              'text-2xl font-semibold',
              variantStyles
            )}>
              {value}
            </p>
            
            {trend && (
              <div className={clsx('text-xs font-normal', trendStyles)}>
                {trend.value}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}